const initialState = {
    responseListManagers: [],
    errorResponseListManagers: false,
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };

    switch (action.type) {
        case "GET_MANGERS_LIST_RESPONSE":
            newState.responseListManagers = action.value;
            if (action.value === undefined) {
                newState.errorResponseListManagers = true;
            } else {
                newState.errorResponseListManagers = false;
            }
            break;

        default:
            return newState;
    }

    return newState;
};

export default reducer;